/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} All_Rights_ReservedInputs */

const en_all_rights_reserved = /** @type {(inputs: All_Rights_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All rights reserved.`)
};

const tr_all_rights_reserved = /** @type {(inputs: All_Rights_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm hakları saklıdır.`)
};

/**
* | output |
* | --- |
* | "All rights reserved." |
*
* @param {All_Rights_ReservedInputs} inputs
* @param {{ locale?: "en" | "tr" }} options
* @returns {LocalizedString}
*/
export const all_rights_reserved = /** @type {((inputs?: All_Rights_ReservedInputs, options?: { locale?: "en" | "tr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<All_Rights_ReservedInputs, { locale?: "en" | "tr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_all_rights_reserved(inputs)
	return tr_all_rights_reserved(inputs)
});